import React, { createElement } from 'react';
import './index.css';
import ReactDOM from 'react-dom/client';
import { App } from './App';
// Warm up the connection to the image CDN as early as possible so the hero
// mockup (the largest asset / LCP) starts loading without TCP+TLS delay.
if (typeof document !== 'undefined') {
  const cdn = 'https://cdn.magicpatterns.com';
  const addLink = (rel: string, crossOrigin?: boolean) => {
    const link = document.createElement('link');
    link.rel = rel;
    link.href = cdn;
    if (crossOrigin) link.crossOrigin = 'anonymous';
    document.head.appendChild(link);
  };
  addLink('preconnect', true);
  addLink('dns-prefetch');
}
const rootEl = document.getElementById('root');
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<App data-id="element-290" />);
}